import { useEffect } from 'react'

const BASE_TITLE = 'BNKR'

/** Sets document title for the active route. */
export function useCrtPageTitle(title: string | null) {
  useEffect(() => {
    document.title = title ? `${title} · ${BASE_TITLE}` : BASE_TITLE
  }, [title])
}
